<template>
  <div class="main">
    <img class="banner" src="@/assets/images/service_amh.png" alt="">
    <el-row type="flex" justify="center">
      <el-col :xs="24" :sm="19">
        <img src="@/assets/images/amh1.png" alt="" />
        <img src="@/assets/images/amh3.png" alt="" />
        <img src="@/assets/images/amh2.png" alt="" />
        <img src="@/assets/images/amh4.png" alt="" />
        <img src="@/assets/images/amh5.png" alt="" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Product_amh",
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>

.el-row{
  justify-content: center;
  text-align: center;
  .el-col{
    margin-top: 20px;
    img{
      width: 100%;
      max-width: 800px;
      height: auto;
    }
  }
}
</style>
